import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 850px;
  text-align: center;
  align-items: center;
  justify-content: center;
`

export const Icon = styled.span`
  font-size: 64px !important ;
  color: ${colors.primary};
`

export const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  line-height: 32px;
  color: ${colors.primary};
`

export const Description = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: ${colors.strongGray};
`
